export class PerfilAcesso {
	id: number;
    nome: string;
    descricao: string;
}



// WEBPACK FOOTER //
// ./src/app/usuarios/perfis-acesso.ts